// *********************   NOTE:   ********************//
//  Share Dropdown function in /js/modules/dropdown.js
// ****************************************************//
const shareit = function() {
	// Replace All String
	String.prototype.replaceAll = function(search, replacement) {
		var target = this;
		return target.replace(new RegExp(search, 'g'), replacement);
	};

	// Get MetaTags
	function getMetaByProperty(metaName, encode) {
		var metas = document.getElementsByTagName('meta');

		for (var i = 0; i < metas.length; i++) {
			if (metas[i].getAttribute('property') === metaName) {
				var desc = metas[i].getAttribute('content');
				if (encode === 'uri') {
					var cleanDesc = encodeURIComponent(desc);
				} else {
					var cleanDesc = desc.replaceAll(' ', '+');
				}
				return cleanDesc;
			}
		}
		return false;
	}

	// Link selector and pop-up window size
	var Config = {
		Link: '.shareit',
		Width: 500,
		Height: 500
	};

	// Add handler links
	var slink = document.querySelectorAll(Config.Link);
	for (let a = 0; a < slink.length; a++) {
		// See if specific link needs to be shared
		let windowLocation = function() {
				if (slink[a].dataset.link) {
					return slink[a].dataset.link;
				} else {
					return encodeURIComponent(window.location);
				}
			}
			// Switch Case for Share Link Type
		switch (slink[a].dataset.shareto) {
			// facebook
            // + '&picture=' + encodeURIComponent(getMetaByProperty('og:image'))
			case 'facebook':
                slink[a].setAttribute('href', 'https://www.facebook.com/sharer/sharer.php?&u=' + windowLocation() + '&title=' + getMetaByProperty('og:title') + '&description=' + getMetaByProperty('og:description'));
				slink[a].onclick = PopupHandler;
				break;

				// twitter
			case 'twitter':
				let description;
				// twitter
				// for text use `text=${description}`
				if (getMetaByProperty('twitter:description')) {
					description = getMetaByProperty('twitter:description');
				} else {
					description = getMetaByProperty('og:description')
                }
                slink[a].setAttribute('href', 'https://twitter.com/intent/tweet?t&url=' + windowLocation() + '&title=' + getMetaByProperty('og:title'));
				slink[a].onclick = PopupHandler;
				break;

				// google
				// case 'share js-share_google':
				// 	slink[a].setAttribute('href', `https://plus.google.com/share?url=${windowLocation()}`);
				// 	slink[a].onclick = PopupHandler;
				// 	break;

				// email
            case 'email':
                var title = getMetaByProperty('og:title');
                title = title.split('+').join(' ');
                title = encodeURIComponent(title);
                slink[a].setAttribute('href', 'mailto:?body=' + windowLocation() + '&subject=' + title);
				break;

				// print
			case 'print':
				window.print();
			
			// linkedIn
			case 'linkedin':
                slink[a].setAttribute('href', 'https://www.linkedin.com/shareArticle?mini=true&url=' + windowLocation() + '&title=' + getMetaByProperty('og:title') + '&ro=false&summary=' + getMetaByProperty('og:description'));
				slink[a].onclick = PopupHandler;
				break;

			default: // No Designated Link Type
				break;
		}
	}
	// Create popup
	function PopupHandler(event) {
		event = (event ? event : window.event);
		var t = (event.currentTarget ? event.currentTarget : event.srcElement);
		// Popup position
		var px = Math.floor(((screen.availWidth || 1024) - Config.Width) / 2);
		var py = Math.floor(((screen.availHeight || 700) - Config.Height) / 2);
		// Open popup
		var popup = window.open(t.href, "social",
			"width=" + Config.Width + ",height=" + Config.Height +
			",left=" + px + ",top=" + py +
			",location=0,menubar=0,toolbar=0,status=0,scrollbars=1,resizable=1");
		if (popup) {
			popup.focus();
			if (event.preventDefault) event.preventDefault();
			event.returnValue = false;
		}
		return !!popup;
	}
}

var shareElement = document.querySelectorAll('.js-shareit');
if (shareElement.length !== 0) {
	shareit();
}



// WEBPACK FOOTER //
// ../components/social/social.js


// WEBPACK FOOTER //
// ../components/social/social.js